import { getFormattedValueQuickFilterText, getCommonQuickFilterText } from "./filter-helpers";
import { CustomColumnType } from "./grid-column-types";
const getKeyCreator = (params, groupAllowUnbalanced) => {
    // If a groupKeyField is provided on the colDef, use the underlying raw field value for the key
    const groupKeyField = params.colDef?.groupKeyField;
    if (groupKeyField && params.data) {
        const raw = params.data[groupKeyField];
        if (raw !== undefined && raw !== null && raw !== "") {
            return raw;
        }
    }
    if (params.value) {
        return params.value;
    }
    return groupAllowUnbalanced === true ? null : "N/A";
};
const getSetFilter = (def) => {
    if (def.filter === "agSetColumnFilter") {
        return def;
    }
    if (def.filterParams?.filters?.length) {
        for (const filter of def.filterParams?.filters ?? []) {
            const found = getSetFilter(filter);
            if (found) {
                return found;
            }
        }
    }
    return null;
};
const setKeyCreator = (def, groupAllowUnbalanced) => {
    def.keyCreator = (p) => getKeyCreator(p, groupAllowUnbalanced);
    const filter = getSetFilter(def);
    if (filter) {
        filter.filterParams = { ...filter.filterParams ?? {}, valueFormatter: (p) => p.value?.toString() };
    }
};
const shouldApplyQuickFilter = (def) => {
    if (!def || def.getQuickFilterText) {
        return false;
    }
    if (!def.type) {
        return true;
    }
    return def.type.indexOf(CustomColumnType.InsLinkColumn) === -1 &&
        def.type.indexOf("auxTextColumn") === -1;
};
const applyQuickFilterText = (def) => {
    def.getQuickFilterText = def.valueFormatter && typeof def.valueFormatter !== "string"
        ? getFormattedValueQuickFilterText
        : getCommonQuickFilterText;
};
const applyColumnState = (def, specificColState) => {
    if (!specificColState) {
        return;
    }
    if (specificColState.rowGroup) {
        def.rowGroup = true;
        def.rowGroupIndex = specificColState.rowGroupIndex;
    }
    else {
        def.rowGroup = false;
    }
};
export const getColumnDefsWithQuickFilterTexts = (columnDefs, columnState, sectionId, widgetId, groupAllowUnbalanced) => {
    if (!columnDefs) {
        return columnDefs;
    }
    columnDefs.forEach((columnDef) => {
        const def = columnDef;
        const groupDef = columnDef;
        const specificColState = columnState?.find((colState) => colState.colId === def.field);
        applyColumnState(def, specificColState);
        setKeyCreator(def, groupAllowUnbalanced);
        if (shouldApplyQuickFilter(def)) {
            applyQuickFilterText(def);
            def.cellRendererParams = { ...def.cellRendererParams, sectionId, widgetId };
        }
        if (groupDef?.children?.length) {
            const children = getColumnDefsWithQuickFilterTexts(groupDef.children, columnState, sectionId, widgetId, groupAllowUnbalanced);
            if (children) {
                groupDef.children = children;
            }
        }
    });
    return columnDefs;
};
export const isCurrentRowTheFooter = (rowNode) => (rowNode?.level ?? 1) < 0;
export const getColDefs = (columnDefs, dataSelectTableFilterProps, tableFilterSelectedValue) => {
    if (!columnDefs || !dataSelectTableFilterProps) {
        return columnDefs;
    }
    const { selectBy } = dataSelectTableFilterProps.select;
    if (!selectBy) {
        return columnDefs;
    }
    return columnDefs.map((colDef) => ({
        ...colDef,
        cellClassRules: {
            ...colDef.cellClassRules || {},
            "ag-row-selected": ({ data }) => Boolean(data) && String(data[selectBy]) === tableFilterSelectedValue
        }
    }));
};
const getSortedDataBySelectBy = (data, selectBy) => {
    if (!selectBy || !data) {
        return data;
    }
    return [...data].sort((a, b) => {
        const aVal = a?.[selectBy];
        const bVal = b?.[selectBy];
        if (aVal === null && bVal === null) {
            return 0;
        }
        if (aVal === null) {
            return 1;
        }
        if (bVal === null) {
            return -1;
        }
        return String(aVal).localeCompare(String(bVal));
    });
};
export const getTableData = (displayedRowData, dataSelectTableFilterProps, tableFilterSelectedValue) => {
    if (!dataSelectTableFilterProps) {
        return displayedRowData;
    }
    const { groupBy, selectBy } = dataSelectTableFilterProps.select;
    if (!groupBy || !tableFilterSelectedValue) {
        return displayedRowData;
    }
    const sortedData = getSortedDataBySelectBy(displayedRowData, selectBy);
    return (sortedData || []).filter((row) => String(row?.[groupBy]) === tableFilterSelectedValue);
};
